import React from 'react'
import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { Table } from './Table';

const PoRateAproval = (permissions: IPermissionProps) => {

    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);
    return (
        <>
            <Table toast={toast} reload={reload} permissions={permissions} />
            <Toast ref={toast} />
        </>
    )
}

export default PoRateAproval
